module.exports = __webpack_public_path__ + "static/img/p_15.27ed6b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_15.png
// module id = 5QJD
// module chunks = 9